<app-header></app-header>

<main>

  @if (!statesService.states.started) {
    <app-giftbox></app-giftbox>
  }

  @if (statesService.states.started && simulation.pet != null && simulation.pet.life > 0 ) {
    <app-gameplay></app-gameplay>
  }

  @if (simulation.pet != null && simulation.pet.life <= 0 && statesService.states.started) {
    <app-grave></app-grave>
  }

</main>
